import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7effe8d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-dark navbar-expand-sm fixed-bottom bottom-0 justify-content-between row ski-footer allrights" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("p", null, "© " + _toDisplayString(_ctx.currentYear) + " - Steel King Industries, Inc. All Rights Reserved.", 1)
  ]))
}